import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { ServerapiService } from 'src/app/serverapi.service';

@Component({
  selector: 'app-cancer-doctor-registration',
  templateUrl: './cancer-doctor-registration.component.html',
  styleUrls: ['./cancer-doctor-registration.component.css']
})
export class CancerDoctorRegistrationComponent implements OnInit {

  languages = '';
  sectionTraningModule;
  flag;
  route = '/doctor';
  patientId;
  personalMobile;
  
  isEditing=false;

  countryId = '';
  stateId = '';
  // districtId = '';
  countryList;
  stateList;
  sendingList=[];
  hstateList;
  hdistrictList;
  hcountryId = '';
  hstateId = '';
  hdistrictId = '';
  districts;
  districtList;
  reason;
  emailValue;
  cancerDoctorSendingList=[];
  seldistrict;
  finalCountry;
  finalState;
  finalDistrictlist=[];
  seldesignation = '';
  deis = '0';
  desig = "null";
  selHeading;
  specialityEditList =[];
  doctorEditList =[];
  selActivity;
  headingMasterToDoList;
  activityMasterToDoList;
  countryListForDoctor;
  submitted = false;
  countryListForCancer;
  stateListForCancer;
  districtListForCancer;
  cncrDctrRegDetailsList: cncrDctrRegList[] = [];
  specialities: Speciality[] = [];
  // cncrDctrRegDetailsList : cncrDctrRegList[] = [];
  data = new Data();
  cdr = new cncrDctrRegList();
  speciality = new Speciality();
  spec = [];
  cancerDoctorList;
  cdrList;
  specialityListForRender;
  cdrListForRender;
  id;
  currentDoctorId;
  count  = '';
  
  // materialDispatchDtList : cancerDoctorRegForm[] = [];
  constructor(private serverAPI: ServerapiService, private fb: FormBuilder,
    private toastr: ToastrService, private dialog: MatDialog,
  ) { }
  cancerDoctorForm;
  cancerDoctorRegForm = this.fb.group({
    speciality: ['', Validators.required],
    cncrTime: ['', Validators.required],
    appointmentNo: ['', Validators.required],
    name: ['', Validators.required],
    country: ['101', Validators.required],
    state: ['', Validators.required],
    district: ['', Validators.required],
    address: ['', Validators.required],
  });

  ngOnInit() {
    // this.languages = localStorage.getItem('language') !== 'null' ? localStorage.getItem('language') : '';
    // this.getAllSectionsByLanguage();
    // this.id = this.speciality.id;
    this.speciality.id = localStorage.getItem('id');
    // this.flag = localStorage.getItem('flag');
    this.getAllCancerDoctorRegDetails();
    this.getAllCountryForCancerDoctor();
  }

  redirection() {
    if (this.flag === 'adminDashboard') {
      this.route = '/admin';
    }
  }
  getAllCountryForCancerDoctor() {
    this.serverAPI.getCountries().subscribe(data => {
      this.countryListForCancer = data;
      console.log(this.countryListForCancer);
    
      if (this.cdr.country) {
        // this.cdr.state='';
        this.getAllStateByCountryIdForCancerDoctor();
      }
    });
  }
  getAllStateByCountryIdForCancerDoctor() {
    this.serverAPI.getStates(this.cdr.country).subscribe(data => {
      this.stateListForCancer = data;
      if (this.cdr.state) {
        // this.cdr.district='';
        this.getAllDistrictForCancerDoctor();
      }
    });
  }
  getAllDistrictForCancerDoctor() {
    this.serverAPI.getDistricts(this.cdr.state).subscribe(
      data => {
        this.districtListForCancer = data;
        // this.district = '';
        // this.update();
        // this.toDoListForm.controls.  district.setValue(localStorage.getItem('role') === 'DistrictAdmin' ?
        // localStorage.getItem('districtId') : '');
      }
    );
  }



  checkNumber(event: any, type: string) {
    const pattern = /[0-9\ ]/;
    const decimal = /^[0-9]+([.,][0-9]{1,2})?$/;
    const inputChar = String.fromCharCode(event.charCode);
    if (type === 'decimal') {
      if (!decimal.test(inputChar)) {
        event.preventDefault();
      } else {
        const val = event.target.value;
        if (val <= 0) {
          event.target.value = '';
        }
      }
    } else {
      if (!pattern.test(inputChar) && event.charCode !== '0') {
        event.preventDefault();
      } else {
        const val = event.target.value;
        if (val <= 0) {
          event.target.value = '';
        }
      }
    }
  }



editingDoctor(docId){


}


  addCncrDctrDt() {
    if (this.cdr.country && this.cdr.state  && this.cdr.district && this.cdr.cncrTime && this.cdr.appointmentNo && this.spec && this.reason && this.cdr.name && this.emailValue && this.personalMobile && this.cdr.address) {


      
      this.finalCountry=this.cdr.country;
      this.finalState=this.cdr.state;
      
      

     
      const cncrDt = new cncrDctrRegList();
      // cncrDt.speciality = this.cancerDoctorRegForm.value.speciality;
      const c = this.countryListForCancer.find(o => Number(o.id) === Number(this.cdr.country));
      if (c) {
      cncrDt.countryname = c.name;
      }
      const s = this.stateListForCancer.find(p => Number(p.id) === Number(this.cdr.state));
      if (s) {
      cncrDt.stateName = s.name;
      }
      
      const d = this.districtListForCancer.find(q => Number(q.id) === Number(this.cdr.district));
      if (d) {
      cncrDt.districtName = d.name;
      const districtList = {
        'id':this.cdr.district,
        'name':d.name
      }
      this.finalDistrictlist.push(districtList);
      console.log("prinitng the value of curent districtList",districtList);
      }

      
      cncrDt.country = this.cdr.country;
      cncrDt.state = this.cdr.state;
      cncrDt.district = this.cdr.district;
      cncrDt.cncrTime = this.cdr.cncrTime;
      cncrDt.appointmentNo = this.cdr.appointmentNo;
      cncrDt.name = this.cdr.name;
      cncrDt.address = this.cdr.address;
      cncrDt.address = this.cdr.address;

      // this.cncrDctrRegDetailsList.push(cncrDt);
      // console.log( this.cncrDctrRegDetailsList);
      // let regDT;
      // const c = this.countryListForCancer.find(o => Number(o.id) === Number(this.cdr.country));
      // if (c) {
      //   this.cdr.country = c.name;
      // }
      // const s = this.stateListForCancer.find(o => Number(o.id) === Number(this.cdr.state));
      // if (s) {
      //   cncrDt.state = s.name;
      // }
      // const d = this.districtListForCancer.find(o => Number(o.id) === Number(this.cdr.district));
      // if (d) {
      //   cncrDt.district = d.name;
      // }
      // cncrDt.state = regDT.state;
      // cncrDt.district = regDT.district;
      // cncrDt.cncrTime = regDT.cncrTime;
      //   cncrDt.appointmentNo = regDT.appointmentNo;
      this.cncrDctrRegDetailsList.push(cncrDt);
      // this.cncrDctrRegDetailsList.push(regDT);
      // const s = new Speciality();
      // s.speciality = this.spec.speciality;
      console.log( "prinitng the value of the List",this.cncrDctrRegDetailsList);
      // this.specialities.push(s);

      // this.cancerDoctorRegForm.value.country ='';
      // this.cancerDoctorRegForm.value.state ='';
      // this.cancerDoctorRegForm.value.district ='';
      // this.cancerDoctorRegForm.value.cncrTime ='';
      // this.cancerDoctorRegForm.value.appointmentNo ='';
      // this.selSuppDt = undefined;
      // this.selMatDt = undefined;
      // this.countryListForCancer =[];
      // this.stateListForCancer =[];
      // this.districtListForCancer = [];
      // this.resetform();
      this.partialEmpty();
    } else {
      this.toastr.warning('please fill the mandatory feilds');

    }

  }

  partialEmpty(){
    this.cdr.cncrTime ='';
    this.cdr.appointmentNo ='';
    this.cdr.district='';
    this.cdr.address='';

  }


  // getAllSectionsByLanguage() {
  //   this.getAllSectionsByLanguageAndTranning();
  //   localStorage.setItem('language', this.languages);
  //   localStorage.setItem('redirectFlag', 'doc_tranning');
  // }

  // getAllSectionsByLanguageAndTranning() {
  //   this.server.getAllSectionsByLanguageAndType(this.languages, 'training').subscribe(
  //     data => {
  //       this.sectionTraningModule = data;
  //     }
  //   );
  //   if (this.languages === '') {
  //     this.sectionTraningModule = null;
  //   }
  // }
  getAllCountry() {
    this.serverAPI.getCountries().subscribe(data => {
      this.countryList = data;
      if (this.countryId) {
        this.getAllStateByCountryId();
      }
      if (this.hcountryId) {
        this.getStateByCountryId();
      }
    });
  }
  getAllStateByCountryId() {
    this.serverAPI.getStates(this.countryId).subscribe(data => {
      this.stateList = data;
      if (this.stateId) {
        this.getAllDistrictByStateId();
      }
    });
  }
  getStateByCountryId() {
    this.serverAPI.getStates(this.hcountryId).subscribe(data => {
      this.hstateList = data;
      if (this.hstateId) {
        this.getDistrictByStateId();
      }
    });
  }
  getAllDistrictByStateId() {
    this.serverAPI.getDistricts(this.stateId).subscribe(data => {
      this.districtList = data;
    });
  }
  getDistrictByStateId() {
    this.serverAPI.getDistricts(this.hstateId).subscribe(data => {
      this.districts = data;
      // if (this.districtId) {
      //   this.getAllDesignation();
      // }
    });
  }

  // clearFilter() {
  //   this.hcountryId = '';
  //   this.hstateId = '';
  //   this.seldistrict = '';
  //   this.selectedDate = '';
  //   this.selHeading = '';
  //   this.selActivity = '';
  //   this.getAllToDoListByPatientId();

  // }

  // getManageToDoListByCriteria() {
  //   if (!this.hcountryId) {
  //     this.hcountryId = '0';
  //   }
  //   const s = this.seldistrict;
  //   if (s) {
  //     this.deis = this.seldistrict;
  //   }
  //   if (!this.hstateId) {
  //     this.hstateId = '0';
  //   }
  //   if (!this.deis) {
  //     this.deis = '0';
  //   }
  //   // const d = this.seldesignation;
  //   // if (d) {
  //   //   this.desig = this.seldesignation;
  //   // }
  //   // if (!this.desig) {
  //   //   this.desig = 'null';
  //   // }
  //   if (!this.selectedDate) {
  //     this.selectedDate = 'null';
  //   }
  //   if (!this.selHeading) {
  //     this.selHeading = '0';
  //   }
  //   if (!this.selActivity) {
  //     this.selActivity = '0';
  //   }
  //   this.serverAPI.getManageToDoListByCriteria(this.hcountryId, this.hstateId, this.deis, this.selHeading, 
  //     this.selActivity ,this.selectedDate).subscribe(
  //     data => {
  //       console.log(data);
  //       this.toDoMasterList = data != null ? data : new Array();
  //     });
  //     const tempToDoMasterList = [];
  //     // const date = this.selectedDate;
  //     this.toDoMasterList.forEach(toDoList => {
  //       if (this.selectedDate === this.datePipe.transform(toDoList.doDate, 'yyyy-MM-dd')) {
  //         tempToDoMasterList.push(toDoList);
  //       }
  //     });

  // }

  get validMsg() {
    return this.cancerDoctorRegForm.controls;
  }

  changeFlag() {
    console.log("Test");
  }
  // getAllFunctionalOutComeCategory() {
  //   this.serverAPI.getAllFunctionalOutComeCategory().subscribe(data => {
  //     this.functionalOutComeCategoryList = data;
  //   });
  // }
  saveCancerDoctor() {
    // this.submitted = true;
    // if (this.cancerDoctorRegForm.invalid) {
    //   return;
    // }
    // const cancerDoctorRegFormData = this.cancerDoctorRegForm.value;
    // cancerDoctorRegFormData.isActive = 1;
    // if (this.cancerDoctorForm) {
    //   cancerDoctorRegFormData.id = this.cancerDoctorForm.id;
    //   // cancerDoctorRegFormData.country = this.cancerDoctorForm.country;
    //   // cancerDoctorRegFormData.state = this.cancerDoctorForm.state;
    //   // cancerDoctorRegFormData.district = this.cancerDoctorForm.district;
    // cancerDoctorRegFormData.speciality = this.cancerDoctorForm.speciality;
    //   // cancerDoctorRegFormData.cncrTime = this.cancerDoctorForm.cncrTime;
    //   // cancerDoctorRegFormData.appointmentNo = this.cancerDoctorForm.appointmentNo;
    //   cancerDoctorRegFormData.createdBy = this.cancerDoctorForm.createdBy;
    //   cancerDoctorRegFormData.createdDate = this.cancerDoctorForm.createdDate;
    //   cancerDoctorRegFormData.updatedBy = parseInt(localStorage.getItem('loginuserid'), 10);
    // } else {
    //   cancerDoctorRegFormData.createdBy = parseInt(localStorage.getItem('loginuserid'), 10);
    //   cancerDoctorRegFormData.updatedBy = parseInt(localStorage.getItem('loginuserid'), 10);
    // }
    // cancerDoctorRegFormData.cancerDoctorRegForm = parseInt(cancerDoctorRegFormData.cncrDctrRegDetailsList, 10);
    // this.specialities, this.cncrDctrRegDetailsList,
    // this.specialities.push(this.spec.speciality);



   

  

    
    for (const obj of this.spec) {
      const s = new Speciality();
      s.speciality = obj;
      this.specialities.push(s);
    }


    if (this.specialities.length <= 0) {
      
      return;
    }


    //   let specialitySTemp : String = "";
    
    
      
    // console.log('checking before saving that it has id',ob.id);
    // if(this.isEditing = true){
      //   tblSpeciality.id =;
      // } 
    const tblSpeciality = new TblSpeciality();
    // console.log("prinitng iD",this.specialityEditList[0].id);
    if(this.isEditing ==true){
      tblSpeciality.id=this.specialityEditList[0].id;
      console.log("this.specialityEditList[0].id :",this.specialityEditList[0].id);
    }
    tblSpeciality.speciality = String(this.spec);
    tblSpeciality.countryId =this.finalCountry;
    if(this.isEditing ==true){
      tblSpeciality.countryId =this.cncrDctrRegDetailsList[0].country;
    }
    tblSpeciality.name =this.cncrDctrRegDetailsList[0].name;
    tblSpeciality.stateId =this.finalState;
    if(this.isEditing ==true){
      tblSpeciality.stateId =this.cncrDctrRegDetailsList[0].state;
    }
    tblSpeciality.mobileNo =this.personalMobile;
    tblSpeciality.email =this.emailValue;
    tblSpeciality.isActive ="1";


    const c = this.countryListForCancer.find(o => Number(o.id) === Number(this.cdr.country));
    if (c) {
      tblSpeciality.countryName = c.name;
    // // this.cncrDctrRegDetailsList[element].countryname = c.name;
    }
    const s = this.stateListForCancer.find(o => Number(o.id) === Number(this.cdr.state));
    if (s) {
      tblSpeciality.stateName = s.name;
    // // this.cncrDctrRegDetailsList[element].countryname = c.name;
    }





    // tblSpeciality.countryName=
    tblSpeciality.reason =String(this.reason);
    this.sendingList.push(tblSpeciality);
  //   specialitySTemp.concat(pillai.toString(),"");
  //   console.log("ptinintg the testing string ",pillai);
  
  // console.log("ptinintg the specialityStemp ",specialitySTemp);
    
    // for (const ob of this.spec){
    //   specialitySTemp.concat(ob.toString());
    // }
    // console.log("prinitng speciality String",specialitySTemp);
    // console.log("prinitng speciality array",tblSpeciality.speciality);
    // console.log("prinitng objct value ",tblSpeciality);
  //   reason;
  // emailValue;
    
    for (const ob of this.cncrDctrRegDetailsList ){
      console.log('checking before saving that it has id',ob.id);
      // console.log("checking the value of cancerDctrList",this.cncrDctrRegDetailsList);
      // console.log("checking the value of cancerDctrList",ob);
      const cancerDoctorReg = new CancerDoctorReg();
      const s = this.finalDistrictlist.find(o => String(o.name) == String(ob.district));
      if (s) {
        
      }
      
      if(this.isEditing == true){
        cancerDoctorReg.id =ob.id;
      } 
      
      
      cancerDoctorReg.districtId = (ob.district);
      cancerDoctorReg.districtName = String(ob.districtName);
      cancerDoctorReg.cncrTime = ob.cncrTime;
      cancerDoctorReg.appointmentNo = ob.appointmentNo;
      if(this.isEditing ==true){
        cancerDoctorReg.districtId = ob.district;
      }
      cancerDoctorReg.isActive = "1";
      cancerDoctorReg.isActive = "1";
      cancerDoctorReg.createdBy = '';
      cancerDoctorReg.createdDate = '';
      cancerDoctorReg.updatedBy ='';
      cancerDoctorReg.updatedBy = '';
      cancerDoctorReg.sp_id = '';
      cancerDoctorReg.address = ob.address;
      this.cancerDoctorSendingList.push(cancerDoctorReg);
    }

    this.serverAPI.saveCancerDoctor(

      { 
        'speciality': this.sendingList,
        //'regList': this.cdr,
        'cncrDctrRegList': this.cancerDoctorSendingList
        }
    ).subscribe(
      cancerDoctorRegFormData => {
        // this.getAllFunctionalOutComeForm();
        // this.cancerDoctorRegForm.controls.speciality.setValue('');
        // this.cancerDoctorRegForm.controls.country.setValue('');
        // this.cancerDoctorRegForm.controls.state.setValue('');
        // this.cancerDoctorRegForm.controls.district.setValue('');
        // this.cancerDoctorRegForm.controls.cncrTime.setValue('');
        // this.cancerDoctorRegForm.controls.appointmentNo.setValue('');
        // if (this.cncrDctrRegDetailsList) {
        this.toastr.success('Update Successfully!', 'Update!');
        // } else {
        //   this.toastr.success('Save Successfully!', 'Success!');
        // }
        // this.cancerDoctorRegForm = '';
        this.isEditing=false;
        this.resetform();
        this.getAllCancerDoctorRegDetails();
        this.cncrDctrRegDetailsList=[];
        this.cancerDoctorSendingList=[];
        this.sendingList=[];
        this.finalDistrictlist=[];
        // setTimeout(this.getAllCancerDoctorRegDetails, 500);
      }
    );
    // this.isEditing=false;
    // this.resetform();
    // setTimeout(this.getAllCancerDoctorRegDetails, 500);
  }
  test(){
    
  }
  resetform(){
    this.isEditing=false;
    this.spec =[];
    this.personalMobile ='';
    this.cdr.country='';
    this.cdr.state='';
    this.cdr.name='';
    this.emailValue=''; 
    this.reason=[];
    this.cdr.cncrTime ='';
    this.cdr.appointmentNo ='';
    this.cdr.district='';
    this.cdr.address='';
  }

  getAllCancerDoctorRegDetails() {
    this.serverAPI.getAllCancerDoctorRegDetails().subscribe(data => {

      // var tempCountryList =[]; 
      // this.serverAPI.getCountries().subscribe(data => {
      //   tempCountryList=data;
      // });

      this.cdrListForRender = data[0];
      console.log("prinitng the valoe of the distric tlist",this.cdrListForRender);
      this.specialityListForRender = data[1];


      // const c = this.countryListForCancer.find(o => Number(o.id) === Number(this.cdr.country));
      // if (c) {
      // cncrDt.country = c.name;
      // }
      // const s = this.stateListForCancer.find(p => Number(p.id) === Number(this.cdr.state));
      // if (s) {
      // cncrDt.state = s.name;
      // }

    //   console.log("prinitng temproray country List",tempCountryList);
    // for (const ob of  this.specialityListForRender){
    //   const c = tempCountryList.find(o => Number(o.countryId) === Number(ob.countryId));
    //   if (c) {
    //     const index = this.specialityListForRender.findIndex(obj => obj.id === c.id);  
    //     this.specialityListForRender[index].countryId =c.countryId;
    //   }

    // }

    




      
      console.log("cancerDoctor RegisterList",this.cdrListForRender);
      console.log("speciality registerList",this.specialityListForRender);
      // this.count = data.toString();
    });
  }
  getDoctorInfoBySpId(doctorId,specialityId){
    // this.cdr.country=this.cdr.country;
    this.isEditing=true;
    // this.getAllCountryForCancerDoctor();
    this.serverAPI.getDoctorInfoBySpId(doctorId,specialityId).subscribe(data=>{
      this.doctorEditList=[];
      this.specialityEditList=[];
      this.doctorEditList.push(data[0]);
      this.specialityEditList.push(data[1]);
      console.log("prinitng the doctor Specialitylist",this.specialityEditList);
      console.log("prinitng the dta of the doctor  in  List",this.doctorEditList);
      console.log("prinitng the dta of thedata thats coming in as spediality list",data[1]);
      // this.cancerDoctorRegForm.reset();
      this.personalMobile =this.specialityEditList[0].mobileNo;
      this.cdr.country=this.specialityEditList[0].countryId;
      // this.getAllCountryForCancerDoctor();
      this.cdr.state=this.specialityEditList[0].stateId;
      this.getAllStateByCountryIdForCancerDoctor();
      this.cdr.name=this.specialityEditList[0].name;
      this.emailValue=this.specialityEditList[0].email;
      
      const specialityString = this.specialityEditList[0].speciality;
      const specialties = specialityString.replace(/^\[|\]$/g, '').split(',').map(s => s.trim());
      this.spec=specialties;
      
      const reasonString = this.specialityEditList[0].reason;
      const reason = reasonString.replace(/^\[|\]$/g, '').split(',').map(s => s.trim());
      this.reason=reason;
      console.log(reason);
      
      this.cncrDctrRegDetailsList=[];
      for(const ob of this.doctorEditList[0]){
        console.log("prinitng object ",ob);
        
        const cncrDt = new cncrDctrRegList();
        // cncrDt.speciality = this.cancerDoctorRegForm.value.speciality;
        cncrDt.id = ob.id;
        cncrDt.country = this.cdr.country;
        cncrDt.state = this.cdr.state;
        cncrDt.district = ob.districtId;
        cncrDt.cncrTime = ob.cncrTime;
        cncrDt.appointmentNo = ob.appointmentNo;
        cncrDt.name = this.cdr.name;
        cncrDt.address = ob.address;
        cncrDt.districtName = ob.districtName;



        const c = this.countryListForCancer.find(o => Number(o.id) === Number(this.cdr.country));
        if (c) {
          cncrDt.countryname = c.name;
        // this.cncrDctrRegDetailsList[element].countryname = c.name;
        }

        const s = this.stateListForCancer.find(z => Number(z.id) === Number(this.cdr.state));
        if (s) {
          cncrDt.stateName = s.name;
        // this.cncrDctrRegDetailsList[element].stateName = s.name;
        }


        console.log("prinitng the valuye of indivudual object",cncrDt);
        this.cncrDctrRegDetailsList.push(cncrDt);
        
      }

      let currentDoctorInfo;
      
      console.log("prinitng the valuye of this.doctorEditList[0] :",this.doctorEditList[0]);
      for(const ob of this.doctorEditList[0]){
        if(ob.id == doctorId){
          currentDoctorInfo = ob;
          this.cdr.cncrTime =currentDoctorInfo.cncrTime;
          this.cdr.appointmentNo = ob.appointmentNo;
          this.cdr.district=ob.districtId;
          this.cdr.address=ob.address;
        }
      }
      
      console.log("prinitng the valuye of cncer doctor List",this.cncrDctrRegDetailsList);
      // console.log("prinitng the control form values ",this.cancerDoctorRegForm);
      // this.spec=this.specialityEditList[0].speciality;
      
      
      this.changeDoctor(doctorId);
    })

  }
  updateList(){

    this.personalMobile ='';
    this.cdr.country='';
    this.cdr.state='';
    this.cdr.name='';
    this.emailValue='';
    this.cdr.cncrTime ='';
    this.cdr.appointmentNo ='';
    this.cdr.district='';
    this.cdr.address='';




    for(const ob of this.doctorEditList[0]){
      console.log("prinitng object ",ob);
      
      const cncrDt = new cncrDctrRegList();
      // cncrDt.speciality = this.cancerDoctorRegForm.value.speciality;
      cncrDt.id = ob.id;
      cncrDt.country = this.cdr.country;
      cncrDt.state = this.cdr.state;
      cncrDt.district = ob.districtId;
      cncrDt.cncrTime = ob.cncrTime;
      cncrDt.appointmentNo = ob.appointmentNo;
      cncrDt.name = this.cdr.name;
      cncrDt.address = ob.address;
      console.log("prinitng the valuye of indivudual object",cncrDt);
      this.cncrDctrRegDetailsList.push(cncrDt);
      
    
  }


  
  // getFunctionalOutComeFormById(id) {
  //   this.serverAPI.getFunctionalOutComeFormById(id).subscribe(data => {
  //     this.functionalOutcomeForm = data;
  //     this.functionalOutcomeFormForm.controls.functionalOutComeName.setValue(data.functionalOutComeName);
  //     this.functionalOutcomeFormForm.controls.comment.setValue(data.comment);
  //     this.functionalOutcomeFormForm.controls.priority.setValue(data.priority);
  //     this.functionalOutcomeFormForm.controls.functionalOutComeCategory.setValue(data.functionalOutComeCategory.id);
  //   });
  // }

  // deleteFunctionalOutComeFormById(id) {
  //   const message = 'Once you Delete, all your data will be removed. Continue ?';
  //   const dialogRef = this.dialog.open(DeleteDialogComponent, { data: { message: message, btn: 'Delete' } });
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result === 'confirm') {
  //       this.serverAPI.deleteFunctionalOutComeFormById(id).subscribe(
  //         data => {
  //           this.toastr.success('Delete Successfully!', 'Success!');
  //           this.getAllFunctionalOutComeForm();
  //         }
  //       );
  //     }
  //   });
  // }



  // saveDoctor() {
  //   this.submitted = true;
  //   if (this.doctorForm.invalid) {
  //     return;
  //   }
  //   //  this.doctorForm.controls.countryCode.setValue(singlecountry.phonecode);
  //   this.doctorForm.value.clinic === '' ? this.doctorForm.controls.clinic.setValue(this.emptyList)
  //     : this.doctorForm.controls.clinic.setValue(this.doctorForm.value.clinic);
  //   this.doctorForm.value.district = parseInt(this.doctorForm.value.district, 10);
  //   this.doctorForm.get('countryCode').enable();
  //   this.server.postDoctor(this.doctorForm.value).subscribe(
  //     data => {
  //       this.submitted = false;
  //       this.doctorForm.reset();
  //       this.doctortype = this.route.snapshot.paramMap.get('type');
  //       if (this.doctortype === 'personal') {
  //         this.doctorTitle = 'Independent';
  //         this.doctortype = 'I';
  //       } else if (this.doctortype === 'clinic') {
  //         this.doctorTitle = 'Empanelled';
  //         this.doctortype = 'E';
  //       }
  //       this.reload();
  //       this.toastr.success('Save Successfully!', 'Success!');
  //       window.location.href = this.configuration.SERVER.portalLoginPageUrl;
  //     }
  //   );
  // }

  // delete(id) {
  //   const message = 'Once you Delete, all your data will be removed. Continue ?';
  //   const dialogRef = this.dialog.open(DeleteDialogComponent, { data: { message: message, btn: 'Delete' } });
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result === 'confirm') {
  //       this.server.deleteDoctor(id).subscribe(
  //         data => {
  //           this.reload();
  //           this.toastr.success('Delete Successfully!', 'Success!');
  //         }
  //       );
  //     }
  //   });
  // }

}
changeDoctor(docId){
  console.log("prinitng doctor ID",docId);
  this.currentDoctorId = docId;
  let currentDoctorInfo;
    
    console.log("prinitng the valuye of this.doctorEditList[0] :",this.doctorEditList[0]);
    
    for(const ob of this.doctorEditList[0]){
      if(ob.id == docId){
        currentDoctorInfo = ob;
        this.cdr.cncrTime =currentDoctorInfo.cncrTime;
        this.cdr.appointmentNo = ob.appointmentNo;
        this.cdr.district=ob.districtId;
        this.cdr.address=ob.address;
      }
    }
    
  }
  updateChangesInList(){

   if (this.cdr.country && this.cdr.state !='' && this.cdr.district && this.cdr.cncrTime && this.cdr.appointmentNo && this.spec && this.reason && this.cdr.name && this.emailValue && this.personalMobile && this.cdr.address) {
 this.getAllCountryForCancerDoctor();

 console.log("prinitng the valoe of country",this.cdr.country);
      console.log("prinitng the valoe of state ",this.cdr.state);
      console.log("prinitng the valoe of district",this.cdr.district);
    
  console.log("prinitng the valuye of cancerDoctorRegisterList :",this.cncrDctrRegDetailsList);
  console.log("prinitng the array that should be send to Edit",this.doctorEditList[0][0].id);
  
  const registredDoctor =this.cncrDctrRegDetailsList;
  const index = registredDoctor.findIndex(obj => obj.id === this.currentDoctorId);

  console.log("prinitng the index ",index);
  var  element = 0;



    
    for (const ob of this.cncrDctrRegDetailsList){


      const c = this.countryListForCancer.find(o => Number(o.id) === Number(this.cdr.country));
      if (c) {
      c.countryname = c.name;
      this.cncrDctrRegDetailsList[element].countryname = c.name;
      }
      const s = this.stateListForCancer.find(o => Number(o.id) === Number(this.cdr.state));
      if (s) {
      s.stateName = s.name;
      this.cncrDctrRegDetailsList[element].stateName = s.name;
      }
      
      this.cncrDctrRegDetailsList[element].country =Number(this.cdr.country);
      this.cncrDctrRegDetailsList[element].state =Number(this.cdr.state);
      this.cncrDctrRegDetailsList[element].name =(this.cdr.name);
      console.log("cjhecking loop",element);
      element++;
    } 
  
  this.cncrDctrRegDetailsList[index].district =Number(this.cdr.district);
  
  
  
  const d = this.districtListForCancer.find(q => Number(q.id) === Number(this.cdr.district));
  if (d) {
    // cncrDt.districtName = d.name;
    this.cncrDctrRegDetailsList[index].districtName =(d.name);
  }




  this.cncrDctrRegDetailsList[index].cncrTime =Number(this.cdr.cncrTime);
  this.cncrDctrRegDetailsList[index].appointmentNo =(this.cdr.appointmentNo);
  this.cncrDctrRegDetailsList[index].address =(this.cdr.address);
  
  console.log("AfterUpdation",this.cncrDctrRegDetailsList);
  
  this.partialEmpty();
    }
    else{
      this.toastr.warning('please fill the mandatory feilds');
    }
}
}


// speciality
export class Speciality {
  id: string;
  speciality: string;
  uniqueno: string;
}
// cdr
export class cncrDctrRegList {
  id: string;
  country;
  state;
  district;
  cncrTime;
  appointmentNo;
  name;
  address;
  uniqueno: string;
  countryname:string;
  districtName:string;
  stateName:string;
}

export class TblSpeciality{
  id: string;
  speciality :string;
	name;
	mobileNo;
	email;
	countryId;
	stateId;
	isActive;
  reason;
  countryName :string;
  stateName:string;
}


export class CancerDoctorReg{
	 id :string;
	cncrTime;
	appointmentNo;
	districtId;
	isActive;
	createdBy;
	createdDate;
  districtName :string;
	updatedBy;
	updatedDate;
	address;
  sp_id;
}

class Data {
  Speciality = [];
  cncrDctrRegList = [];
}